export default __webpack_public_path__ + "static/media/Path 54352.6b5b7f72.svg";